export default {
  data () {
    return {
      secondsPressed: 0,
      interval: false
    }
  },

  methods: {
    startCounter () {
      if ((this.seconds - this.secondsPressed) === 0) {
        this.onCounterFinish()
      } else {
        this.interval = setInterval(() => {
          if ((this.seconds - this.secondsPressed) > 0) {
            this.secondsPressed++
          } else {
            this.onCounterFinish()
          }
        }, 1000)
      }
    },

    restartCounter () {
      if (this.interval) clearInterval(this.interval)
      this.interval = false
      this.secondsPressed = 0
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/holdDown.js